import MrtReferralsReportVirtualized from "@/components/Table/MrtReferralsReportVirtualized.tsx";
import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { Stack, Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";

const ReportReferrals = (): ReactNode => {
    const { hasPermission } = useEmployee();

    if (!hasPermission("view:report-referrals")) {
        return <div>You do not have access to this page.</div>;
    }

    useEffect(() => {
        document.title = "Reports";
    }, []);

    return (
        <Stack
            sx={{
                flexGrow: 1,
                height: "100%",
                display: "flex",
            }}
        >
            <Typography variant="h4" mb={2}>
                Report: Referrals
            </Typography>
            <MrtReferralsReportVirtualized />
        </Stack>
    );
};

export default ReportReferrals;
